<template><div class="home">

<div class="text-h5 text-center pa-5"> Sorry, this page hasn't been translated yet :( </div>

</div></template>

<script>

export default {
	components: {},
	data() {
		return {

		}
	},
	methods: {

	},
	created() {

	}
}
</script>
